import React, { useEffect, useState } from "react";
import { AccordionSummary } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Grid from "@material-ui/core/Grid";
import Accordion from "@material-ui/core/Accordion";
import TextField from "@material-ui/core/TextField";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Button from "@material-ui/core/Button";
import SaveOutlinedIcon from "@material-ui/icons/SaveOutlined";
import { format } from "date-fns";
import { putUserData } from "../../../../../api";
import { ACCORDION_USER_PERSONAL_DATA, MESSAGE_USER_PERSONAL_INFO_UPDATE } from "../../../../../utils/constants";
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import AlertDialog from "../../../../../components/custom-dialog/CustomDialogComponent";
import { useIntl } from "react-intl";

const UserPersonalDataComponent = ({ classes, id, idCrm, user, handleGetUser, expanded, handleSetExpanded }) => {
  const intl = useIntl();

  const [userAlias, setUserAlias] = useState("");
  const [userNIF, setUserNIF] = useState("");
  const [userBirthday, setUserBirthday] = useState(format(new Date(), "MM/dd/yyyy"));
  const [openInfo, setOpenInfo] = useState(false);

  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    if (!!user) {
      setUserAlias(user?.datosPersonales?.alias || "");
      setUserNIF(user?.datosPersonales?.dni || "");
      const formattedDate = format(new Date(user?.datosPersonales?.fechaNacimiento), "MM/dd/yyyy");
      setUserBirthday(formattedDate);
    }
  }, [user]);

  const handleSetUserAlias = (value) => {
    setUserAlias(value);
  };

  const handleSetUserNIF = (value) => {
    setUserNIF(value);
  };

  const handleSetUserBirthday = (value) => {
    setUserBirthday(value);
  };

  useEffect(() => {
    if (user) {
      setDisabled(
        ((user.datosPersonales.alias === null && userAlias === "") || userAlias === user.datosPersonales?.alias) &&
          userNIF === user.datosPersonales?.dni &&
          userBirthday === format(new Date(user?.datosPersonales?.fechaNacimiento), "MM/dd/yyy"),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userAlias, userNIF, userBirthday]);

  const handleResponse = () => {
    handleGetUser();
    setDisabled(true);
  };

  const handleEditPersonalInfo = () => {
    const date = format(new Date(userBirthday), "yyyy-MM-dd'T'HH:mm:ss.SSSXX");

    const body = {
      dni: userNIF,
      alias: userAlias,
      fechaNacimiento: date,
      idUsuario: id,
    };

    putUserData(idCrm, body, handleResponse, { id: MESSAGE_USER_PERSONAL_INFO_UPDATE });
  };

  const handleRestoreData = () => {
    setUserAlias(user.datosPersonales?.alias);
    setUserNIF(user.datosPersonales?.dni);
    setUserBirthday(format(new Date(user?.datosPersonales?.fechaNacimiento), "MM/dd/yyy"));
  };

  const handleOpenInfo = (e) => {
    e.preventDefault();
    setOpenInfo((openInfo) => !openInfo);
  };

  const InfoModalContent = () => {
    return <Typography dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: "custom.info.personal_data" }) }} />;
  };

  return (
    <>
      <Accordion expanded={!!expanded.includes(ACCORDION_USER_PERSONAL_DATA)}>
        <AccordionSummary aria-controls="panel1bh-content" id="panel1bh-header">
          <div className={classes.accordionHeader}>
            <Typography
              onClick={() => handleSetExpanded(ACCORDION_USER_PERSONAL_DATA)}
              className={classes.accordionTitle}
              variant={"h6"}
            >
              {intl.formatMessage({ id: "custom.user.user_data_personal" })}
            </Typography>
            <Button startIcon={<InfoOutlinedIcon />} onClick={handleOpenInfo}>
              {intl.formatMessage({ id: "ra.action.more_info" })}
            </Button>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <Grid item xs={12} container spacing={4}>
            <Grid item xs={4} sm={4} md={4} lg={2}>
              <TextField
                disabled={!user}
                label={intl.formatMessage({ id: "custom.user.alias" })}
                value={userAlias}
                variant="outlined"
                onChange={(e) => handleSetUserAlias(e.target.value)}
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={2}>
              <TextField
                disabled={!user}
                label={intl.formatMessage({ id: "custom.user.cif_nif" })}
                value={userNIF}
                variant="outlined"
                onChange={(e) => handleSetUserNIF(e.target.value)}
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={2}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  disabled={!user}
                  className={classes.datePicker}
                  disableFuture
                  variant="inline"
                  format="dd/MM/yyyy"
                  margin="normal"
                  id="date-picker-from"
                  label={intl.formatMessage({ id: "custom.user.birthday" })}
                  value={userBirthday}
                  onChange={(date) => handleSetUserBirthday(date)}
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={3}>
              <Button
                disabled={disabled}
                startIcon={<SaveOutlinedIcon />}
                className={classes.button}
                onClick={handleEditPersonalInfo}
              >
                {intl.formatMessage({ id: "ra.action.save" })}
              </Button>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={3}>
              <Button
                startIcon={<CancelOutlinedIcon />}
                disabled={disabled}
                onClick={handleRestoreData}
                className={classes.iconButton}
              >
                {intl.formatMessage({ id: "ra.action.erase" })}
              </Button>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      <AlertDialog
        openAlert={openInfo}
        handleClose={handleOpenInfo}
        title={intl.formatMessage({ id: "custom.user.user_data_personal" })}
        cancelButtonText={intl.formatMessage({ id: "ra.action.close" })}
        content={<InfoModalContent />}
      />
    </>
  );
};

export default UserPersonalDataComponent;
